var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7345 4.08398H21.6445C19.9877 4.08398 18.6445 5.42713 18.6445 7.08398V10.339C18.6445 11.9958 19.9877 13.339 21.6445 13.339H27.7345C29.3914 13.339 30.7345 11.9958 30.7345 10.339V7.08398C30.7345 5.42713 29.3914 4.08398 27.7345 4.08398Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2805 13.6094H7.10547C6.27704 13.6094 5.60547 14.2809 5.60547 15.1094V34.3544C5.60547 35.1828 6.27704 35.8544 7.10547 35.8544H42.2805C43.1089 35.8544 43.7805 35.1828 43.7805 34.3544V15.1094C43.7805 14.2809 43.1089 13.6094 42.2805 13.6094Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17766 11.2529C5.15766 11.2529 4.34766 11.9028 4.34766 12.7118V21.1999C4.34766 22.7914 13.4527 24.0646 24.6877 24.0646C35.9227 24.0646 45.0277 22.7782 45.0277 21.1999V12.7118C45.0277 11.9028 44.2027 11.2529 43.1977 11.2529H6.17766Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0531 19.8877H22.3269C21.8249 19.8877 21.418 20.3185 21.418 20.8498V27.277C21.418 27.8084 21.8249 28.2391 22.3269 28.2391H27.0531C27.5551 28.2391 27.962 27.8084 27.962 27.277V20.8498C27.962 20.3185 27.5551 19.8877 27.0531 19.8877Z",
    fill: "#8CC947",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployment);
export default __webpack_public_path__ + "static/media/employment.e4d440be7a9a92896c11e05c6a2b9ef2.svg";
export { ForwardRef as ReactComponent };